












































































import { Component, Vue } from "vue-property-decorator";
import { Button, Toast, Popup, Picker, Loading, Icon } from "vant";
import customField from "@/components/customField/index.vue";
import { login } from "@/utils/hybirdMethods";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [customField.name]: customField
  }
})
export default class Login extends Vue {
  form: any = {
    zone_code: "852",
    phone: "",
    captcha: "",
    code: "",
    key: "",
    login_type: 2 //1密码，2短信
  };
  img = "";
  isSendVerCode = false;
  verCodeTime = 120;
  verCodeTimer: any = null;
  showZoneCodePicker = false;
  zoneCodeColumns:any = [];
  isCaptchaLoading = true;
  isCaptchaError = false;

  get isDisabledSubmit() {
    let flag = false;
    for (const key in this.form) {
      if (!this.form[key] && key !== "key") {
        flag = true;
        break;
      }
    }
    return flag;
  }

  created() {
    this.zoneCodeColumns = [
      {
        text: this.$t('mki18n.t00005'),
        value: "852"
      },
      {
        text: this.$t('mki18n.t00006'),
        value: "86"
      }
    ];
    this.handleGetCaptcha();
  }

  handleGetCaptcha() {
    this.isCaptchaLoading = true;
    this.isCaptchaError = false;
    (this as any).$apis
      .getCaptcha()
      .then(res => {
        
        this.isCaptchaLoading = false;
        const { key, img } = res;
        this.form.key = key;
        this.img = img;
      })
      .catch(e => {
        this.isCaptchaLoading = false;
        this.isCaptchaError = true;
        
      });
  }

  handleConfirmZoneCode(item) {
    this.form.zone_code = item.value;
    this.showZoneCodePicker = false;
  }

  verifyPhone() {
    if (this.form.zone_code == "86") {
      return isChinaPhone(this.form.phone);
    } else if (this.form.zone_code == "852") {
      return isHKPhone(this.form.phone);
    }
  }

  handleSendVerCode() {
    const { captcha, key } = this.form;
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    if (!this.form.captcha) return this.$toast.fail("请填写图片验证码");
    const params = {
      captcha,
      key
    };
    (this as any).$apis
      .verifyCaptcha(params)
      .then(res => {
        
        this.sendVerCode();
      })
      .catch(e => {
        
      });
  }

  sendVerCode() {
    const { phone, zone_code } = this.form;
    const params = {
      phone,
      zone_code,
      msg_show: 1,
      type: 1 //1登录，2注册，3找回密码
    };
    (this as any).$apis
      .sendVerCode(params)
      .then(res => {
        Toast(this.$t("common.message_send_success_text"));
        const { code } = res;
        this.form.code = code;
        this.isSendVerCode = true;
        this.setIntervalSendCode();
        
      })
      .catch(e => {
        
      });
  }

  setIntervalSendCode() {
    const now = new Date().getTime();
    const end = new Date(now + this.verCodeTime * 1000).getTime();
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
      if (this.verCodeTime <= 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  handleSubmit() {
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    (this as any).$apis
      .login(this.form)
      .then(res => {
        
        const { token, user_info } = res;
        (this as any).$localstorage.set("userInfo", user_info);
          sessionStorage.setItem("token", token);
        if (browser.isGetProApp) {
          this.$router.push({
            path: "/mode-select"
          });
        } else if (browser.isApp) {
          login(res);
        } else {
          this.$router.go(-1);
        }
      })
      .catch(e => {
        
      });
  }
}
